module.exports = __webpack_public_path__ + "public/images/why-outschool-doodle-top-left.2f1311479aecfc2e7a134ea92a67a1b9.webp";